import { WorkflowInfoMetricsResponse } from '@/types/composer-dashboard';
import { apiRequest } from '@/utils/api-request';

export const getWorkflowInfoMetrics = async (
  orgId: string,
  labelIds?: string[],
): Promise<WorkflowInfoMetricsResponse> => {
  const params = labelIds?.length
    ? '?' +
      labelIds.map((id) => `label_ids=${encodeURIComponent(id)}`).join('&')
    : '';

  const response = await apiRequest<WorkflowInfoMetricsResponse>({
    url: `/api/v1/orgs/${orgId}/admin/metrics/workflow-info${params}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  if (!response.data) {
    throw new Error('Failed to fetch workflow info metrics');
  }

  return response.data;
};
